module.exports = __webpack_public_path__ + "static/media/image-skeleton.92584cf9.svg";